import { cva, VariantProps } from "class-variance-authority";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export interface SigninDetailsProps
    extends VariantProps<typeof SigninDetailsStyles> {
    isPresales: boolean;
    children?: ReactNode;
    className?: string;
}

export const SigninDetailsStyles = cva(
    "flex flex-col items-left justify-center gap-2 lg:mt-10 px-4 md:px-8",
);

export const SigninDetails = ({
    className,
    isPresales,
}: SigninDetailsProps): JSX.Element => {
    const { t } = useTranslation();
    const stepsData = t(isPresales ? "campagne.steps" : "regular.steps", {
        returnObjects: true,
    });
    const steps = Array.isArray(stepsData) ? stepsData : [];

    return (
        <div className={twMerge(SigninDetailsStyles({ className }))}>
            <div className="flex flex-col text-xl">
                {steps &&
                    steps.length > 0 &&
                    steps.map((step, index) => {
                        const spaceIndex = step.indexOf(" ");
                        const number = step.slice(0, spaceIndex);
                        const text = step.slice(spaceIndex + 1);
                        return (
                            <div key={index}>
                                <div className="border-t border-white/20" />
                                <div className="flex items-start gap-4 py-4 ">
                                    <span className="bg-gradient-ba bg-clip-text text-transparent font-bold text-base shrink-0 w-8">
                                        {number}
                                    </span>
                                    <span className="text-white/90 text-base leading-relaxed text-left">
                                        {text}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                <div className="border-t border-white/20" />
            </div>
            <div className="flex bg-gray-500 rounded w-4/5 mx-auto gap-4 p-4 mt-4">
                <div className="rounded-lg px-2 uppercase h-fit bg-off-white-500 text-xs">
                    {t("campagne.tip.title")}
                </div>
                <div className="text-white text-sm text-left pr-4">
                    {t("campagne.tip.description")}
                </div>
            </div>
        </div>
    );
};
